import PropTypes from 'prop-types';

export const ANALYTICS_LABEL_MAP = {
    '/access-levels/': 'AccessLevels',
    '/apps/bandsintown': 'BandsintownPromoter',
    '/apps/conference-badges': 'CustomBadges',
    '/apps/eventkingdom': 'DesignerInvitations',
    '/apps/fanzone': 'SharedTransportation',
    '/apps/goldstar': 'Goldstar',
    '/apps/mailchimp': 'MailChimpSync',
    '/apps/membership': 'MembershipManagement',
    '/apps/presdo-match': 'CustomMobileApp',
    '/apps/surveymonkey': 'SurveyMonkey',
    '/apps/toneden': 'FacebookAndInstagramAds',
    createinvite: 'EmailInvitations',
    '/e/': 'listing',
    directory: 'discovery',
    '/facebook-publish?eid=': 'AddToFacebook',
    home: 'home',
    '/language?eid=': 'EventTypeAndLanguage',
    '/links?eid=': 'TrackingLinks',
    multi_event_discounts: 'DiscountAndAccessCodes',
    myevents: 'myevents',
    '/myevent?eid=': 'EventDashboard',
    '/myevents/apps/': 'BrowseExtensions',
    mytickets: 'mytickets',
    '/orderconfirmation/': 'orderconfirmation',
    'order-confirmation': 'OrderConfirmation',
    '/reports?eid=': 'Orders',
    '/tracking/': 'TrackingPixels',
    '/questions?eid=': 'OrderForm',
    '/waitlist-settings?eid=': 'Waitlist',
    'web-integration': 'Widgets',
    '/zone-management/': 'Zones',
};
export const TRACK_EVENT_REQUIRED_PROPS = ['category', 'action'];
export const EB_GA_PROPERTY_FOR_GA = [
    'page',
    'referrer',
    'useBeacon',
    'location',
    'hostname',
    'title',
];

export const GA_SETTINGS_PROP_TYPE = PropTypes.shape({
    isActive: PropTypes.bool,
    userPartnerId: PropTypes.string,
    guestPartnerId: PropTypes.string,
    correlationId: PropTypes.string,
    activeScopeUserId: PropTypes.string,
});
